import { updateNotiSettings } from './ajax';

const NOTI_TOGGLE_IDS = [
	// Coach settings
	'student_assigned', 'video_session', 'student_questions', 'journey_milestones',
	// Student settings
	'coach_msg', 'weigh_in', 'new_stage',
];

export function handleToggleReceiveNoti() {
	// Handle individual notification toggles
	NOTI_TOGGLE_IDS.forEach((id) => {
		const toggle = document.getElementById(id);
		if (!toggle) return;

		toggle.addEventListener('change', async () => {
			try {
				const data = await updateNotiSettings({
					[id]: toggle.checked ? '1' : '0',
				});

				if (data.success) {
					wpcore.showAlert('success', data.data.message);
				} else {
					wpcore.showAlert('error', data.data.message);
					toggle.checked = !toggle.checked;
				}
			} catch {
				toggle.checked = !toggle.checked;
			}
		});
	});

	// Legacy: handle receive_noti toggle if exists
	const legacyToggle = document.getElementById('receive_noti');
	if (legacyToggle) {
		legacyToggle.addEventListener('change', async () => {
			try {
				const data = await updateNotiSettings({
					receive_noti: legacyToggle.checked ? '1' : '0',
				});

				if (data.success) {
					wpcore.showAlert('success', data.data.message);
				} else {
					wpcore.showAlert('error', data.data.message);
					legacyToggle.checked = !legacyToggle.checked;
				}
			} catch {
				legacyToggle.checked = !legacyToggle.checked;
			}
		});
	}
}

export function handleFcmPopupClosed() {
	document.addEventListener('popup-closed', async (e) => {
		if (e.detail?.target !== 'fcm-permission') return;
		if (Notification.permission !== 'granted') {
			await updateNotiSettings({ receive_noti: '0' });
		}
	});
}

export function handlePermissionChange() {
	document.addEventListener('notification-permission-changed', async () => {
		await updateNotiSettings({ receive_noti: Notification.permission === 'granted' ? '1' : '0' });
	});
}
